import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getCurrentTime16j9973nx5x63 as getCurrentTime } from './internal/KLoggingClock.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var KLoggingEventClass;
function KLoggingEvent() {
  if (KLoggingEventClass === VOID) {
    class $ {
      constructor(level, marker, loggerName, message, cause, payload, timestamp) {
        return new.target.a2g(level, marker, loggerName, message, cause, payload, timestamp);
      }
      static a2g(level, marker, loggerName, message, cause, payload, timestamp) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        payload = payload === VOID ? null : payload;
        timestamp = timestamp === VOID ? getCurrentTime() : timestamp;
        var $this = createThis(this);
        $this.h2f_1 = level;
        $this.i2f_1 = marker;
        $this.j2f_1 = loggerName;
        $this.k2f_1 = message;
        $this.l2f_1 = cause;
        $this.m2f_1 = payload;
        $this.n2f_1 = timestamp;
        return $this;
      }
      static b2g(level, marker, loggerName, eventBuilder) {
        return this.a2g(level, marker, loggerName, eventBuilder.s2f_1, eventBuilder.t2f_1, eventBuilder.u2f_1);
      }
      toString() {
        return 'KLoggingEvent(level=' + this.h2f_1.toString() + ', marker=' + toString(this.i2f_1) + ', loggerName=' + this.j2f_1 + ', message=' + this.k2f_1 + ', cause=' + toString(this.l2f_1) + ', payload=' + toString(this.m2f_1) + ', timestamp=' + this.n2f_1.toString() + ')';
      }
      hashCode() {
        var result = this.h2f_1.hashCode();
        result = imul(result, 31) + (this.i2f_1 == null ? 0 : hashCode(this.i2f_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.j2f_1) | 0;
        result = imul(result, 31) + (this.k2f_1 == null ? 0 : getStringHashCode(this.k2f_1)) | 0;
        result = imul(result, 31) + (this.l2f_1 == null ? 0 : hashCode(this.l2f_1)) | 0;
        result = imul(result, 31) + (this.m2f_1 == null ? 0 : hashCode(this.m2f_1)) | 0;
        result = imul(result, 31) + getBigIntHashCode(this.n2f_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KLoggingEvent()))
          return false;
        var tmp0_other_with_cast = other instanceof KLoggingEvent() ? other : THROW_CCE();
        if (!this.h2f_1.equals(tmp0_other_with_cast.h2f_1))
          return false;
        if (!equals(this.i2f_1, tmp0_other_with_cast.i2f_1))
          return false;
        if (!(this.j2f_1 === tmp0_other_with_cast.j2f_1))
          return false;
        if (!(this.k2f_1 == tmp0_other_with_cast.k2f_1))
          return false;
        if (!equals(this.l2f_1, tmp0_other_with_cast.l2f_1))
          return false;
        if (!equals(this.m2f_1, tmp0_other_with_cast.m2f_1))
          return false;
        if (!(this.n2f_1 === tmp0_other_with_cast.n2f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'KLoggingEvent');
    KLoggingEventClass = $;
  }
  return KLoggingEventClass;
}
//region block: exports
export {
  KLoggingEvent as KLoggingEvent3el01063mcenm,
};
//endregion

//# sourceMappingURL=KLoggingEvent.mjs.map
